export const headers = [
  { name: 'Usuário', field: 'username', sortable: true },
  { name: 'Ativo', field: 'active', sortable: false }
]
